// eslint-disable-next-line quotes
import { defineStore } from "pinia"
import services from '@/services'
import { useUsersStore } from '@/stores/users'
import { useGroupsStore } from "@/stores/groups"
import { orderIdDesc } from '@/helpers/messages'

import { DataAudit, payloadAudit } from '@/types/internalChatAxios'
import { ItemMessageChat } from '@/types/itemsMessages'

interface RootState {
  items: DataAudit[];
  messages:ItemMessageChat[]
  bearer: string;
  has_more_messages: boolean;
  loading: boolean;
}

export const useAuditStore = defineStore({
  id: 'audit',
  state: (): RootState => ({
    bearer: '',
    has_more_messages: true,
    loading: false,
    items: [],
    messages:[],
  }),
  /*
  */
  getters: {
    all: (state) => state.items,
    config: (state) => {
        return {
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json',
                Authorization: 'Bearer ' + state.bearer
            }
        }
    },
    getById: (state) => (id: number) => state.items.find((el) => el.id === id),
    // getById: (state) => (id: number) => findById(state.items, id)
  },
  /*
  */
  actions: {
    async initialize () {
        const response = await services.audit.initialize()
        if (!response.errors) {
            const userStore = useUsersStore()
            const groupStore = useGroupsStore()

            userStore.upItems(response.data.users)
            groupStore.upItems(response.data.groups)
        }


        return response
    },
    upBearer (bearer : string) {
        this.bearer = bearer
    },
    addMessages (payload: ItemMessageChat[]) {
        if (!payload || payload.length === 0) return
        for (const message of payload) {
            this.addMessage(message)
        }
    },
    addMessage( payload: ItemMessageChat ): void {
        if (!payload) {
            return
        }
        if (this.messages.length === 0) {
            this.messages = [payload]
        }
        else if (!this.messages.find((el) => el.uuid === payload.uuid)) {
            this.messages.push(payload)
        } else {
            // JA POSSUI uma mensagem com o mesmo uuid
            // console.log('possui o mesmo uuid ' + payload.uuid)
        }
    },
    resetMessages() {
        this.messages.length = 0
    },
    async search (payload: payloadAudit, origin : string = '') {
        if(payload.with === 'user') {
            if (!payload.sender || !payload.recipient) {
                throw new Error('not selected user')
            }
        }
        if(payload.with === 'group') {
            if (!payload.group) {
                throw new Error('not selected group')
            }
        }

        this.loading = true
        payload.offset = this.messages.length
        const response = await services.audit.findMessage(payload)
        this.loading = false
        if (response.errors) {
          throw new Error('error request findMessageUser')
        }

        if (response.data) {
          if (origin === 'search') {
            this.messages = response.data.data
          }else{
            const result = orderIdDesc(response.data.data)
            this.addMessages(result)
          }
          this.has_more_messages = !!(response.data.data.length > 0)

          return response.data.data
        }
    },
  }
})
